(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    scope.querySelectorAll('.desktop-nav .nav-dropdown').forEach(dropdown => {
      if (dropdown.dataset.initialized) return;
      dropdown.dataset.initialized = 'true';
      const summary = dropdown.querySelector('summary');
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        scope.querySelectorAll('.desktop-nav .nav-dropdown').forEach(other => {
          if (other !== dropdown) other.open = false;
        });
      });
      document.addEventListener('pointerdown', event => {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      });
      dropdown.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          dropdown.open = false;
          summary.focus();
        }
      });
    });
    const menuButton = scope.querySelector('.menu-toggle');
    const menu = scope.querySelector('#MobileMenu');
    if (menuButton && menu && !menuButton.dataset.initialized) {
      menuButton.dataset.initialized = 'true';
      const closeMenu = () => {
        menu.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
      };
      menuButton.addEventListener('click', () => {
        const open = menu.hidden;
        menu.hidden = !open;
        menuButton.setAttribute('aria-expanded', String(open));
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { closeMenu(); menuButton.focus(); }
      });
      menuButton.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
    }
    if ('IntersectionObserver' in window && !reduceMotion.matches) {
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            reveal.unobserve(entry.target);
          }
        });
      }, { threshold: .06 });
      document.body.classList.add('motion-ready');
      scope.querySelectorAll('[data-reveal]').forEach(element => reveal.observe(element));
    }
    scope.querySelectorAll('.thumbnail').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const image = document.querySelector('#MainProductImage');
        if (!image) return;
        image.src = button.dataset.image;
        image.removeAttribute('srcset');
        image.alt = button.dataset.alt || '';
        document.querySelectorAll('.thumbnail').forEach(thumb => {
          thumb.classList.toggle('is-active', thumb === button);
          thumb.setAttribute('aria-pressed', String(thumb === button));
        });
      });
    });
    scope.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = document.querySelector('[data-product-price]');
        const compare = document.querySelector('[data-product-compare]');
        const button = document.querySelector('[data-add-button]');
        const text = document.querySelector('[data-add-text]');
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (compare) { compare.hidden = !option.dataset.compare; compare.textContent = option.dataset.compare || ''; }
        if (button) button.disabled = !available;
        if (text) text.textContent = available ? select.dataset.addLabel : select.dataset.soldLabel;
        const image = document.querySelector('#MainProductImage');
        if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('[data-sort]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (!reduceMotion.matches && window.innerWidth > 800) {
    const hero = document.querySelector('[data-parallax]');
    if (hero) {
      let scheduled = false;
      window.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          hero.style.transform = `translateY(${Math.min(window.scrollY * .07, 45)}px)`;
          scheduled = false;
        });
      }, { passive: true });
    }
  }
})();
